import { createAsyncThunk } from '@reduxjs/toolkit'
import { authApi, AuthApiTypes, HTTPClientTypes } from 'api'
import { RegistrationRequest, RejectValue } from './types'
import { isMigrationSelector } from './selectors'
import { RootState } from 'redux/store'
import {
  CheckRegistrationCodeResponse,
  MigrationCodeResponse,
} from 'api/auth/types'

export const sendRegistrationCode = createAsyncThunk<
  { isMigration: boolean; registrationCode: string; email: string },
  { code: string; isMigration: boolean },
  RejectValue
>(
  'registration/sendCode',
  async ({ code, isMigration }, { rejectWithValue }) => {
    try {
      let data: MigrationCodeResponse | CheckRegistrationCodeResponse
      if (isMigration) {
        const migrationCodeResponse = await authApi.checkMigrationCode(code)
        data = migrationCodeResponse.data
      } else {
        const registrationCodeResponse = await authApi.checkRegistrationCode(
          code
        )
        data = registrationCodeResponse.data
      }

      const isMigrationResponse = (
        response: MigrationCodeResponse | CheckRegistrationCodeResponse
      ): response is MigrationCodeResponse => 'migrationCode' in response

      return {
        isMigration,
        registrationCode: isMigrationResponse(data)
          ? data.migrationCode
          : data.registrationCode,
        ...data,
      }
    } catch (error) {
      return rejectWithValue(
        (error as HTTPClientTypes.ErrorResponse).responseStatus.message
      )
    }
  }
)

export const registration = createAsyncThunk<
  AuthApiTypes.RegistrationResponse,
  RegistrationRequest,
  { state: RootState; rejectValue: RejectValue }
>(
  'registration',
  async ({ code, password, onSuccess }, { rejectWithValue, getState }) => {
    try {
      const state = getState()
      const isMigrationFromState = isMigrationSelector(state)

      if (isMigrationFromState) {
        await authApi.migrate(code, password)
      } else {
        await authApi.register(code, password)
      }
      if (onSuccess) {
        onSuccess()
      }
    } catch (error) {
      return rejectWithValue({
        rejectValue: (error as HTTPClientTypes.ErrorResponse).responseStatus
          .message,
      })
    }
  }
)
